export default function MasterclassOverview() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Ein <span className="text-yellow-500">360°-Blick</span> auf Dubai &amp; die VAE
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Begleitet von tiefem Insiderwissen, echten Praxisbeispielen und einem Gastredner, der zu den erfahrensten deutschsprachigen Experten in Dubai zählt.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border-2 border-blue-200">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Vergangenheit</h3>
            <p className="text-gray-700 leading-relaxed">
              Vom Wüstenhandel zur Weltmetropole – die faszinierende Transformation Dubais in wenigen Jahrzehnten.
            </p>
          </div>

          <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-8 border-2 border-yellow-200">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-building-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Gegenwart</h3>
            <p className="text-gray-700 leading-relaxed">
              Das heutige Ökosystem für internationale Investoren – Steuern, Infrastruktur, Wirtschaftskraft.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 border-2 border-green-200">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Zukunft</h3>
            <p className="text-gray-700 leading-relaxed">
              Massive wirtschaftliche Chancen der nächsten 10–20 Jahre in Dubai, den VAE und der GCC-Region.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-12 text-white">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">
                Was Sie in dieser Masterclass erwartet
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <span className="text-lg">Kompletter Deep Dive in den Immobilienmarkt (Off-Plan vs. Ready)</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <span className="text-lg">Firmengründungen, Freezones &amp; Banking in allen 7 Emiraten</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <span className="text-lg">GCC-Länder im Vergleich: Saudi-Arabien, Katar, Bahrain, Oman, Kuwait</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <span className="text-lg">Crypto, Compliance &amp; Regulierung in Dubai</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <span className="text-lg">Echte Zahlen, echte Projekte, echte Beispiele</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/05d89e462ef613d6674169cfc32aefdf.jpg"
                alt="Dubai Masterclass Seminar"
                className="w-full h-80 object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
